import React from 'react';
import AppRouter from './router';
import PWAInstallPrompt from './components/PWAInstallPrompt';

function App() {
  return (
    <>
      <AppRouter />
      <PWAInstallPrompt />
    </>
  );
}

export default App;
